import { AvatarsContainer } from './AvatarsContainer';
import { AvatarsItem } from './AvatarsItem';

export default {
  AvatarsContainer,
  AvatarsItem,
};
